import { TenantEntity } from '../TenantEntity'
import { getOverseaAgentUserList } from '@/api/partner/overseaAgentUser'

export class OverseaAgent extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get billAddress() {
    return this._data.billAddress
  }
  set billAddress(billAddress) {
    this._data.billAddress = billAddress
  }
  get forcastAddress() {
    return this._data.forcastAddress
  }
  set forcastAddress(forcastAddress) {
    this._data.forcastAddress = forcastAddress
  }
  get blAddress() {
    return this._data.blAddress
  }
  set blAddress(blAddress) {
    this._data.blAddress = blAddress
  }
  get blAddressLine2() {
    return this._data.blAddressLine2
  }
  set blAddressLine2(blAddressLine2) {
    this._data.blAddressLine2 = blAddressLine2
  }
  get blAddressLine3() {
    return this._data.blAddressLine3
  }
  set blAddressLine3(blAddressLine3) {
    this._data.blAddressLine3 = blAddressLine3
  }
  get blAddressLine4() {
    return this._data.blAddressLine4
  }
  set blAddressLine4(blAddressLine4) {
    this._data.blAddressLine4 = blAddressLine4
  }
  get blAddressLine5() {
    return this._data.blAddressLine5
  }
  set blAddressLine5(blAddressLine5) {
    this._data.blAddressLine5 = blAddressLine5
  }
  get blAddressLine6() {
    return this._data.blAddressLine6
  }
  set blAddressLine6(blAddressLine6) {
    this._data.blAddressLine6 = blAddressLine6
  }
  get blAddressLine7() {
    return this._data.blAddressLine7
  }
  set blAddressLine7(blAddressLine7) {
    this._data.blAddressLine7 = blAddressLine7
  }
  get blNotifyAddressLine1() {
    return this._data.blNotifyAddressLine1
  }
  set blNotifyAddressLine1(blNotifyAddressLine1) {
    this._data.blNotifyAddressLine1 = blNotifyAddressLine1
  }
  get blNotifyAddressLine2() {
    return this._data.blNotifyAddressLine2
  }
  set blNotifyAddressLine2(blNotifyAddressLine2) {
    this._data.blNotifyAddressLine2 = blNotifyAddressLine2
  }
  get blNotifyAddressLine3() {
    return this._data.blNotifyAddressLine3
  }
  set blNotifyAddressLine3(blNotifyAddressLine3) {
    this._data.blNotifyAddressLine3 = blNotifyAddressLine3
  }
  get blNotifyAddressLine4() {
    return this._data.blNotifyAddressLine4
  }
  set blNotifyAddressLine4(blNotifyAddressLine4) {
    this._data.blNotifyAddressLine4 = blNotifyAddressLine4
  }
  get blNotifyAddressLine5() {
    return this._data.blNotifyAddressLine5
  }
  set blNotifyAddressLine5(blNotifyAddressLine5) {
    this._data.blNotifyAddressLine5 = blNotifyAddressLine5
  }
  get blNotifyAddressLine6() {
    return this._data.blNotifyAddressLine6
  }
  set blNotifyAddressLine6(blNotifyAddressLine6) {
    this._data.blNotifyAddressLine6 = blNotifyAddressLine6
  }
  get blNotifyAddressLine7() {
    return this._data.blNotifyAddressLine7
  }
  set blNotifyAddressLine7(blNotifyAddressLine7) {
    this._data.blNotifyAddressLine7 = blNotifyAddressLine7
  }
  get airAddressLine1() {
    return this._data.airAddressLine1
  }
  set airAddressLine1(airAddressLine1) {
    this._data.airAddressLine1 = airAddressLine1
  }
  get airAddressLine2() {
    return this._data.airAddressLine2
  }
  set airAddressLine2(airAddressLine2) {
    this._data.airAddressLine2 = airAddressLine2
  }
  get airAddressLine3() {
    return this._data.airAddressLine3
  }
  set airAddressLine3(airAddressLine3) {
    this._data.airAddressLine3 = airAddressLine3
  }
  get airAddressLine4() {
    return this._data.airAddressLine4
  }
  set airAddressLine4(airAddressLine4) {
    this._data.airAddressLine4 = airAddressLine4
  }
  get airAddressLine5() {
    return this._data.airAddressLine5
  }
  set airAddressLine5(airAddressLine5) {
    this._data.airAddressLine5 = airAddressLine5
  }
  get airAddressLine6() {
    return this._data.airAddressLine6
  }
  set airAddressLine6(airAddressLine6) {
    this._data.airAddressLine6 = airAddressLine6
  }
  get airAddressLine7() {
    return this._data.airAddressLine7
  }
  set airAddressLine7(airAddressLine7) {
    this._data.airAddressLine7 = airAddressLine7
  }
  get airNotifyAddressLine1() {
    return this._data.airNotifyAddressLine1
  }
  set airNotifyAddressLine1(airNotifyAddressLine1) {
    this._data.airNotifyAddressLine1 = airNotifyAddressLine1
  }
  get airNotifyAddressLine2() {
    return this._data.airNotifyAddressLine2
  }
  set airNotifyAddressLine2(airNotifyAddressLine2) {
    this._data.airNotifyAddressLine2 = airNotifyAddressLine2
  }
  get airNotifyAddressLine3() {
    return this._data.airNotifyAddressLine3
  }
  set airNotifyAddressLine3(airNotifyAddressLine3) {
    this._data.airNotifyAddressLine3 = airNotifyAddressLine3
  }
  get airNotifyAddressLine4() {
    return this._data.airNotifyAddressLine4
  }
  set airNotifyAddressLine4(airNotifyAddressLine4) {
    this._data.airNotifyAddressLine4 = airNotifyAddressLine4
  }
  get airNotifyAddressLine5() {
    return this._data.airNotifyAddressLine5
  }
  set airNotifyAddressLine5(airNotifyAddressLine5) {
    this._data.airNotifyAddressLine5 = airNotifyAddressLine5
  }
  get airNotifyAddressLine6() {
    return this._data.airNotifyAddressLine6
  }
  set airNotifyAddressLine6(airNotifyAddressLine6) {
    this._data.airNotifyAddressLine6 = airNotifyAddressLine6
  }
  get airNotifyAddressLine7() {
    return this._data.airNotifyAddressLine7
  }
  set airNotifyAddressLine7(airNotifyAddressLine7) {
    this._data.airNotifyAddressLine7 = airNotifyAddressLine7
  }
  get network() {
    return this._data.network
  }
  set network(network) {
    this._data.network = network
  }
  get owner() {
    return this._data.owner
  }
  set owner(owner) {
    this._data.owner = owner || 0
  }
  get grade() {
    return this._data.grade
  }
  set grade(grade) {
    this._data.grade = grade || 0
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }
  async getOverseaAgentUserList() {
    const data = this._data
    if (typeof data.overseaAgentUserList !== 'object') {
      data.overseaAgentUserList = await getOverseaAgentUserList({ overseaAgentUuid: data.uuid }).then(res => res.data.list)
    }
    return data.overseaAgentUserList
  }
}
